// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-score_wrapper__y1C\\+y {
  background-color: var(--primary-background-color);
  padding: 24px;
  border-radius: 6px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: center;
}

.game-score_header__agQH0 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.game-score_content__M1zdS {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.game-score_inputs__BzdcN {
  display: flex;
  gap: 10px;
  align-items: center;
}

@media (max-width: 768px) {
  .game-score_wrapper__y1C\\+y {
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/game-score.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".wrapper {\n  background-color: var(--primary-background-color);\n  padding: 24px;\n  border-radius: 6px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n  gap: 24px;\n  align-items: center;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.inputs {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .wrapper {\n    flex-direction: column;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `game-score_wrapper__y1C+y`,
	"header": `game-score_header__agQH0`,
	"content": `game-score_content__M1zdS`,
	"inputs": `game-score_inputs__BzdcN`
};
export default ___CSS_LOADER_EXPORT___;
